export const positionRouteName = {
  index: "positions.index",
};

export const positionRoute = [
  {
    path: "/positions",
    name: positionRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "position",
      breadcrumbs: () => {
        return [{ title: "Posisi" }];
      },
    },
  },
];
